<script>
import IMask from 'imask';

export default {
  name: 'UlFormDate',
  props: {
    value: {},
    min: {
      type: Date,
      default: () => new Date(1900, 1, 1),
    },
    max: {
      type: Date,
      default: () => new Date(2099, 1, 1),
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    el: null,
    elFocus: false,
  }),
  computed: {
    options() {
      return {
        mask: Date,
        min: this.min,
        max: this.max,
        format(date) {
          if (!date) {
            return '';
          }
          const day = String(date.getDate())
            .padStart(2, '0');
          const month = String(date.getMonth() + 1)
            .padStart(2, '0');
          const year = date.getFullYear();
          return [day, month, year].join('.');
        },
      };
    },
  },
  watch: {
    value() {
      this.el.typedValue = this.value;
    },
    min() {
      this.update();
    },
    max() {
      this.update();
    },
  },
  methods: {
    update() {
      this.el.updateOptions(this.options);
    },
    blur() {
      this.$emit('blur');
      if (this.elFocus) {
        const val = this.el.typedValue;
        this.$emit('input', val);
        this.$emit('change', val);
      }
      this.elFocus = false;
    },
    focus() {
      this.elFocus = true;
      this.$emit('focus');
    },
    submit() {
      this.$refs.input.blur();
      this.$emit('submit');
    },
  },
  mounted() {
    this.el = IMask(this.$refs.input, this.options);
    this.el.on('accept', () => {
      if (this.elFocus) {
        return;
      }
      const val = this.el.typedValue;
      this.$emit('input', val);
      this.update();
    });
    this.el.typedValue = this.value;
  },
};
</script>
<template>
  <input
    ref="input"
    type="text"
    class="ul-form-input ul-form-date"
    :disabled="disabled"
    @blur="blur"
    @focus="focus"
    @keypress.enter="submit"
  >
</template>
<style lang="scss">
</style>
